import getConfig from 'next/config'

import { Models } from '@grandvision/carts-v2'
import { CommerceToolsApi } from '@grandvision/commercetools'

import { deliveryResolverFactory } from './delivery-resolver-factory'
import { stockResolverFactory } from './stock-resolver-factory'

const { publicRuntimeConfig } = getConfig()
const staticsUrl = publicRuntimeConfig.grandvision.staticsUrl

export const getCartSettings = (
  formatProductUrl: CommerceToolsApi.FormatProductUrl,
  productRoutes?: Record<string, string>
): Models.CartSettings => ({
  readOnly: false,
  productRoutes,
  maximumQuantity: 5,
  isDiscountCodeEnabled: true,
  showCartDiscountDescriptions: true,
  showCartDiscountOnLineItem: true,
  showSubTotal: true,
  showTotalDiscount: true,
  staticsUrl,
  stockResolverFactory,
  deliveryResolverFactory,
  formatProductUrl,
})
